export interface FooterCategory {
  title: string;
  link: string;
}

export interface FoterLinks {
  name: string;
  url: string;
  available: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  state?: { [k: string]: any };
}
export interface FoterApps {
  name: string;
  link: string;
}

export const OPERATED_BY_OPEN_CERT_ID = 'OPERATED_BY_OPEN_CERT';

export enum FooterOperatedTypes {
  CO_RNT_79000 = 'CO_RNT_79000'
}

export const FOOTER_OPERATED_BY_IMAGES = {
  [FooterOperatedTypes.CO_RNT_79000]: 'CO_RNT_79000.png'
};
